import { useEffect, memo, useState } from "react";
import { Spin } from "antd";
import Item from "./Item";
import _ from "lodash";

const Gird = ({ data = [], loading }) => {
    if (loading) {
        return (
            <div style={{ padding: 18, justifyContent: "center" }}>
                <Spin size="large" />
            </div>
        );
    }

    const sortedData = _.orderBy(data, [(item) => item.sort_index ?? -Infinity], "asc");

    return (
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {sortedData.map((item) => {
                return (
                    <div key={item.id}>
                        <Item data={item}></Item>
                    </div>
                );
            })}
        </div>
    );
};

export default memo(Gird);
